import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";
import { fallback, number, object, optional, string } from "valibot";

export const Route = createFileRoute("/new-account")({
  component: lazyRouteComponent(() => import("./+NewAccount")),
  validateSearch: object({
    token: fallback(optional(string(), ""), ""),
    stepIdx: optional(number()),
  }),
  beforeLoad: ({ search }) => {
    return {
      token: search.token,
    };
  },
  loader: ({ context }) => {
    if (!context.token) {
      throw redirect({
        to: "/",
      });
    }
  },
  head: () => ({
    meta: seo({ title: "New Account" }),
  }),
});
